import { StartLoginFn, initStartLoginFn } from './lib/methods/start-login';
import {
    initRedeemMagicLinkForDeviceClaimTrialFn,
    RedeemMagicLinkForDeviceClaimTrialFn,
} from './lib/methods/redeem-magic-link-for-device-claim-trial';
import { initStatusFn, StatusFn } from './lib/methods/status';
import {
    initLoginWithPasswordFn,
    LoginWithPasswordFn,
} from './lib/methods/login-with-password';
import {
    initLoginWithVerificationCodeFn,
    LoginWithVerificationCodeFn,
} from './lib/methods/login-with-verification-code';
import {
    initStartOneTimePasscodeFn,
    StartOneTimePasscodeFn,
} from './lib/methods/start-one-time-passcode';
import {
    initStartAnonymousSessionFn,
    StartAnonymousSessionFn,
} from './lib/methods/start-anonymous-session';
import { initLogoutFn, LogoutFn } from './lib/methods/logout';
import {
    GetOAuthFinalRedirectUriFn,
    initGetOAuthFinalRedirectUriFn,
} from './lib/methods/get-oauth-final-redirect-uri';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { initIsAnonymousFn, IsAnonymousFn } from './lib/methods/is-anonymous';
import {
    initIsAuthenticatedFn,
    IsAuthenticatedFn,
} from './lib/methods/is-authenticated';
import {
    GetIdentityLoginInfoFn,
    initGetIdentityLoginInfoFn,
} from './lib/methods/get-identity-login-info';
import {
    GetAuthenticatedUserInfoFn,
    initGetAuthenticatedUserInfoFn,
} from './lib/methods/get-authenticated-user-info';
import { initLoginSMSFn, LoginSMSFn } from './lib/methods/login-sms';
import { initRefreshFn, RefreshFn } from './lib/methods/refresh';
import {
    AuthenticateWithIdentityGrantFn,
    initAuthenticateWithIdentityGrantFn,
} from './lib/methods/authenticate-with-identity-grant';
import {
    CheckIdentityStateAndLoginSMSIfAccountIdentityFn,
    initCheckIdentityStateAndLoginSMSIfAccountIdentity,
} from './lib/methods/check-identity-state-and-login-sms-if-account-identity';
import {
    GenerateMagicLinkWithEmailAndPasswordFn,
    initGenerateMagicLinkWithEmailAndPasswordFn,
} from './lib/methods/generate-magic-link-with-email-and-password';

export interface DomainAuth {
    status: StatusFn;
    getAuthenticatedUserInfo: GetAuthenticatedUserInfoFn;
    isAnonymous: IsAnonymousFn;
    isAuthenticated: IsAuthenticatedFn;
    generateMagicLinkWithEmailAndPassword: GenerateMagicLinkWithEmailAndPasswordFn;
    redeemMagicLinkForDeviceClaimTrial: RedeemMagicLinkForDeviceClaimTrialFn;
    startAnonymousSession: StartAnonymousSessionFn;
    startLogin: StartLoginFn;
    startOneTimePasscode: StartOneTimePasscodeFn;
    loginWithPassword: LoginWithPasswordFn;
    loginWithVerificationCode: LoginWithVerificationCodeFn;
    authenticateWithIdentityGrant: AuthenticateWithIdentityGrantFn;
    logout: LogoutFn;
    getOAuthFinalRedirectUri: GetOAuthFinalRedirectUriFn;
    getIdentityLoginInfo: GetIdentityLoginInfoFn;
    loginSMS: LoginSMSFn;
    refresh: RefreshFn;
    checkIdentityStateAndLoginSMSIfAccountIdentity: CheckIdentityStateAndLoginSMSIfAccountIdentityFn;
}

export function domainAuth(domainInitPayload: DomainInitPayload): DomainAuth {
    return {
        status: initStatusFn(),
        getAuthenticatedUserInfo:
            initGetAuthenticatedUserInfoFn(domainInitPayload),
        isAnonymous: initIsAnonymousFn(),
        isAuthenticated: initIsAuthenticatedFn(),
        generateMagicLinkWithEmailAndPassword:
            initGenerateMagicLinkWithEmailAndPasswordFn(domainInitPayload),
        redeemMagicLinkForDeviceClaimTrial:
            initRedeemMagicLinkForDeviceClaimTrialFn(domainInitPayload),
        startAnonymousSession: initStartAnonymousSessionFn(domainInitPayload),
        startLogin: initStartLoginFn(domainInitPayload),
        startOneTimePasscode: initStartOneTimePasscodeFn(domainInitPayload),
        loginWithPassword: initLoginWithPasswordFn(domainInitPayload),
        loginWithVerificationCode:
            initLoginWithVerificationCodeFn(domainInitPayload),
        authenticateWithIdentityGrant:
            initAuthenticateWithIdentityGrantFn(domainInitPayload),
        logout: initLogoutFn(domainInitPayload),
        getOAuthFinalRedirectUri:
            initGetOAuthFinalRedirectUriFn(domainInitPayload),
        getIdentityLoginInfo: initGetIdentityLoginInfoFn(domainInitPayload),
        loginSMS: initLoginSMSFn(domainInitPayload),
        refresh: initRefreshFn(domainInitPayload),
        checkIdentityStateAndLoginSMSIfAccountIdentity:
            initCheckIdentityStateAndLoginSMSIfAccountIdentity(
                domainInitPayload,
            ),
    };
}
